import { FC } from 'react';

import DialogWrapper, {
  ActionRow,
  AnimatedBlock,
  CancelButton,
  ImageWrapper,
  OptionsWrapper
} from './Wrapper';

export type ActionOption = {
  label: string;
  value: string;
};

type Title = {
  text: string;
  icon?: string;
};

type ActionSheetProps = {
  title: Title;
  options: ActionOption[];
  onModalClose(): void;
  onChange(value: ActionOption): void;
};

type ActionItemProps = ActionOption & {
  onChange(value: ActionOption): void;
};

const ActionItem: FC<ActionItemProps> = ({ onChange, ...itemProps }) => (
  <ActionRow onClick={() => onChange(itemProps)}>{itemProps.label}</ActionRow>
);

const ActionSheet: FC<ActionSheetProps> = ({
  options,
  onChange,
  onModalClose,
  title: { icon, text }
}) => (
  <DialogWrapper onModalClose={onModalClose}>
    <AnimatedBlock>
      <OptionsWrapper>
        <ActionRow>
          {icon && <ImageWrapper src={icon} alt={text} />}
          {text}
        </ActionRow>
        {options.map(item => (
          <ActionItem key={item.label} {...{ ...item, onChange }} />
        ))}
      </OptionsWrapper>
      <CancelButton onClick={onModalClose}>Cancel</CancelButton>
    </AnimatedBlock>
  </DialogWrapper>
);

export default ActionSheet;
